import { ca } from '@cian/analytics';
import { ITrackServiceItemClickParams, ITrackServicesShowParams } from './types';
import { EPageTypes } from '../../../constants/page';

export const trackShowServicesContainer = ({ mappedServices, pageType }: ITrackServicesShowParams) => {
  ca('teaser', {
    product: {
      name: 'other_services_show',
    },
    page: {
      siteType: 'mobile',
      pageType,
      extra: {
        services: mappedServices,
      },
    },
  });
};

export const trackShowGoToAddFormLink = (pageType: EPageTypes) => {
  ca('teaser', {
    product: {
      name: 'add_form_entry',
    },
    page: {
      siteType: 'mobile',
      pageType,
    },
  });
};

export const trackClickGoToAddFormLink = (pageType: EPageTypes) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'EstateCalculator',
    action: 'Click_sopr',
    label: 'go_to_add_form',
    page: {
      siteType: 'mobile',
      pageType,
    },
  });
};

export const trackClickAllServicesButton = (pageType: EPageTypes) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'EstateCalculator',
    action: 'Click_sopr',
    label: 'All_services_button',
    page: {
      siteType: 'mobile',
      pageType,
    },
  });
};

export const trackClickServiceItem = ({ pageType, label, place }: ITrackServiceItemClickParams) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'EstateCalculator',
    action: 'Click_sopr',
    label,
    page: {
      siteType: 'mobile',
      pageType,
      extra: {
        place,
      },
    },
  });
};
